/**
 * Public URLs of a studio. Every page is a REAL directory in dist/ (each with
 * the studio's own HTML shell), and record ids travel in the query string,
 * so any static host serves the right studio for every deep link without
 * rewrite rules. (Cloudflare Pages turned `_redirects` 200-rewrites to
 * index.html into 308 redirects to the studio root, and 404'd splats.)
 */
export const studioUrl = {
  home: (slug: string) => `/s/${slug}/`,
  services: (slug: string) => `/s/${slug}/services/`,
  my: (slug: string) => `/s/${slug}/my/`,
  booking: (slug: string, id: string) => `/s/${slug}/booking/?id=${encodeURIComponent(id)}`,
  assistant: (slug: string) => `/s/${slug}/assistant/`,
  owner: (slug: string, rest = '') => `/s/${slug}/owner/${rest}`,
  ownerBooking: (slug: string, id: string) => `/s/${slug}/owner/booking/?id=${encodeURIComponent(id)}`,
};

/** Directories under /s/<slug>/ that get a copy of the studio shell. Keep in sync with src/app/router.tsx and OwnerApp. */
export const STATIC_ROUTE_DIRS = [
  'services',
  'my',
  'booking',
  'assistant',
  'owner',
  'owner/bookings',
  'owner/bookings/new',
  'owner/booking',
  'owner/stats',
  'owner/assistant',
  'owner/settings',
  'owner/settings/studio',
  'owner/settings/cards',
  'owner/settings/services',
  'owner/settings/posts',
  'owner/settings/hours',
  'owner/settings/gallery',
] as const;
